import { Notification } from "../types/Notification";
import appClient from "./AppClient";
import { endpoints } from "../../../config";

export default class NotificationsService {
    async getNotificationsForUser(onlyUnread = false) {
        const url =
            endpoints.tasksUrl +
            `notifications${onlyUnread ? "?onlyUnread=true" : ""}`;
        return appClient.get<Notification[]>(url);
    }

    async markNotificationAsRead(notificationId: string) {
        const url =
            endpoints.tasksUrl + `notifications/mark-as-read/${notificationId}`;
        return appClient.update(url);
    }

    async deleteNotification(notificationId: string) {
        const url = endpoints.tasksUrl + `notifications/${notificationId}`;
        return appClient.post(url);
    }

    async markAllAsRead() {
        const url = endpoints.tasksUrl + "notifications/mark-all-as-read";
        return appClient.update(url);
    }
}
